import { render, staticRenderFns } from "./ArticleFilterCheckbox.vue?vue&type=template&id=12952706&scoped=true"
import script from "./ArticleFilterCheckbox.vue?vue&type=script&lang=js"
export * from "./ArticleFilterCheckbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12952706",
  null
  
)

export default component.exports